const API_URL = import.meta.env.VITE_API_URL;

export async function submitContact(data: {
  name: string;
  company?: string;
  need?: string;
  timeline?: string;
  email: string;
  message: string;
  requestedEngagement?: unknown;
  captchaToken: string;
}) {
  const response = await fetch(`${API_URL}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to submit contact');
  }

  return response.json();
}

export async function verifyEmail(data: { email: string; code: string }) {
  const response = await fetch(`${API_URL}/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Verification failed');
  }

  return response.json();
}
